import instance from "../../../axios";

// Funções para listagem de pacientes
export function buscarPacientes() {
  return instance
    .get(process.env.VUE_APP_API_BASE_URL + "pacientes")
    .then((res) => {
      return res;
    })
    .catch((error) => {
      
      throw error;
    });
}
export function excluir(id) {
  const result = {
    showModal: false,
    validacoesSucesso: false,
    msgModal: "",
  };

  return instance
    .get(`${process.env.VUE_APP_API_BASE_URL}paciente-consulta/${id}`)
    .then((res) => {
      if (res.data.acess === "Negado") {
        result.msgModal =
          "Não é possível excluir o paciente pois o mesmo possui consultas agendadas em seu nome";
      } else {
        result.msgModal = "Paciente excluído com sucesso";
        result.validacoesSucesso = true;
      }
      return result;
    })
    .catch((error) => {
      
    });
}

// Funções para cadastrar novo paciente

export function buscarConvenios() {
  return instance
    .get(`${process.env.VUE_APP_API_BASE_URL}convenios`)
    .then((res) => {
      const listaConvenios = res.data
        .filter((elem) => elem.name !== "Coparticipação Saúde Pas")
        .map((elem) => ({ label: elem.name, value: elem.id }));
      return listaConvenios;
    })
    .catch((error) => {
      
      throw error;
    });
}

export function buscarEstados() {
  return instance
    .get(`${process.env.VUE_APP_API_BASE_URL}estados`)
    .then((res) => {
      const estados = res.data.map((elem) => ({
        label: elem.abbreviation,
        value: elem.abbreviation,
      }));
      return estados;
    });
}

export function buscarCidades(uf) {
  return instance
    .get(`${process.env.VUE_APP_API_BASE_URL}cidades/${uf}`)
    .then((res) => {
      const cidades = res.data.map((elem) => ({
        label: elem.name,
        value: elem.name,
      }));
      return cidades;
    });
}

export function buscarCpf(pacienteCpf) {
  const result = {
    showModal: false,
    msgModal: "",
  };

  return instance
    .post(`${process.env.VUE_APP_API_BASE_URL}buscar-cpf`, {
      cpf: pacienteCpf,
    })
    .then((res) => {
      if (res.data.length !== 0) {
        result.showModal = true;
        result.msgModal = "O CPF inserido já está registrado para um paciente.";
      }
      return result;
    })
    .catch((error) => {
      result.showModal = true;
      result.msgModal =
        "CPF com formato inválido, por favor insira todos digitos corretamente";

      return result;
    });
}

export function validarCamposPreenchidos(paciente) {
  const validacoes = {
    nome: !paciente.name,
    cpf: !paciente.cpf,
    email: !paciente.email,
    telefone: !paciente.telefone,
    cidade: !paciente.city,
    endereço: !paciente.end,
    convênio: !paciente.insurance,
    bairro: !paciente.bairro,
    cep: !paciente.cep,
    nf: !paciente.nf,
  };

  let respostaValidacoes = {
    validacoesAviso: false,
    validacoesMessage: "",
  };

  for (const [key, value] of Object.entries(validacoes)) {
    if (value) {
      respostaValidacoes.validacoesAviso = true;
      respostaValidacoes.validacoesMessage = `${key.charAt(0).toUpperCase() +
        key.slice(1)} do paciente precisa ser preenchido`;
      return respostaValidacoes;
    }
  }
  return respostaValidacoes;
}
export function formularioPaciente(camposPreenchidos) {
  const resposta = {
    validacoesSucesso: false,
    validacoesMessage: "",
  };

  if (camposPreenchidos) {
    resposta.validacoesSucesso = true;
    resposta.validacoesMessage = "Cadastro efetuado com sucesso";
  }
  return resposta;
}

export function postPaciente(valoresConvertidos, dadosPaciente) {
  const respostaMsg = "Paciente cadastrado com sucesso";

  try {
    return instance
    .post(`${process.env.VUE_APP_API_BASE_URL}pacientes/novo`, {
      valoresConvertidos,
      paciente: dadosPaciente,
    })
    .then((res) => {
      
      return {respostaMsg,res};
    }).catch((res)=>{
      return { res };

    });
  } catch (error) {
    
    return error
  }
}
